import axios from 'axios';

// If you host frontend on a different origin than DRF:
// - set CORS/CSRF correctly in Django (notes at bottom)
// - keep withCredentials: true so cookies send/receive
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  withCredentials: true,
});

// CSRF support (for session auth). If you use JWT-only, you can remove this.
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

api.interceptors.request.use((config) => {
  // Attach CSRF for unsafe methods if using session auth
  const method = (config.method || 'get').toLowerCase();
  const needsCsrf = ['post', 'put', 'patch', 'delete'].includes(method);
  if (needsCsrf) {
    const csrftoken = getCookie('csrftoken');
    if (csrftoken) config.headers['X-CSRFToken'] = csrftoken;
	if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json';
  }
  return config;
});
